import { DataNode } from 'antd/es/tree';
import { useMemo } from 'react';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import {
  buildCheckableActivityTree,
  checkAllActivities,
} from 'business/shift-report/report-analyze/pages/activity-analyze/services/activity-tree';
import {
  ActivityMinimalTreeFragment,
  Module_Enum,
  useGetTasksAnalyzerMetadataQuery,
} from 'generated/graphql';

export type ActivityTreeMetadata = {
  displayedActivities: DataNode[];
  allActivitiesChecked: string[];
  loading: boolean;
  error: boolean;
};

export const useActivityTree = ({
  constructionSiteId,
}: {
  constructionSiteId: string;
}): ActivityTreeMetadata => {
  const gqlHeaders = useGraphqlApiHeaders(Module_Enum.ShiftReport);

  const { data, loading, error } = useGetTasksAnalyzerMetadataQuery({
    variables: { constructionSiteId: constructionSiteId },
    skip: !constructionSiteId,
    context: {
      headers: gqlHeaders,
    },
  });

  const displayedActivities = useMemo(() => {
    if (data && data.activity.length > 0) {
      return buildCheckableActivityTree(
        data.activity,
        data.hiddenActivitiesWithTasks.map(({ id }) => id),
      );
    }

    return [];
  }, [data]);

  const allActivitiesChecked = checkAllActivities(
    displayedActivities as ActivityMinimalTreeFragment[],
  );

  return {
    displayedActivities: displayedActivities,
    allActivitiesChecked,
    loading,
    error: !!error,
  };
};
